<template>
  <!-- <fwb-dropdown :text="greeting">
    <ul
      class="py-2 text-sm text-gray-700 dark:text-gray-200"
      aria-labelledby="dropdownDefaultButton"
    >
      <li>
        <NuxtLink
          :to="{ path: '/members-area' }"
          class="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-600 dark:hover:text-white"
          >Members Area</NuxtLink
        >
      </li>
      <li>
        <NuxtLink
          :to="{ path: '/my-account' }"
          class="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-600 dark:hover:text-white"
          >My Account</NuxtLink
        >
      </li>
      <li v-if="profile.is_admin">
        <NuxtLink
          :to="{ path: '/admin/data-import' }"
          class="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-600 dark:hover:text-white"
          >Data Import</NuxtLink
        >
      </li>

      <li>
        <a
          href="#"
          @click="onSignOut"
          class="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-600 dark:hover:text-white"
        >
          Sign out
        </a>
      </li>
    </ul>
  </fwb-dropdown> -->
  <UDropdown :items="items" :popper="{ placement: 'bottom-start' }">
    <!-- !bg-transparent !border !border-neutral-200 dark:!border-cardinal-700 text-neutral-950 hover:!bg-cardinal-700 hover:text-white dark:!text-white -->
    <!-- dont want to show this if they bought portal pass while in the middle of their trial -->
    <UTooltip
      v-if="!hasPortalPass && hasActiveTrial"
      :text="`${trialDaysRemaining} days remaining`"
      :popper="{ arrow: true, placement: 'bottom' }"
      class="hidden md:block"
      size="lg"
    >
      <UBadge class="mr-2" color="white">
        <i class="fal fa-clock inline-block mr-1 text-cardinal"></i>
        Trial
      </UBadge>
    </UTooltip>
    <UButton color="white" class="">
      <span class="hidden md:inline">
        {{ greeting }}
      </span>
      <span class="md:hidden">Account</span>
      <i class="fas fa-chevron-down"></i>
    </UButton>
  </UDropdown>
</template>

<script lang="ts" setup>
import { useQueryClient } from '@tanstack/vue-query';
const user = useSupabaseUser();
const supabase = useSupabaseClient();
const store = useProfileStore();
const { $posthog } = useNuxtApp();
const {
  greeting,
  profile,
  hasActiveTrial,
  hasPortalPass,
  hasCurrentPortalPass,
  trialDaysRemaining,
} = storeToRefs(store);
const router = useRouter();
const queryClient = useQueryClient();
const items = computed(() => {
  const items = [
    [
      {
        label: 'My Account',
        icon: 'far far fa-user-circle flex items-center justify-center',
        to: '/my-account',
      },
      {
        label: 'Player Notes',
        icon: hasCurrentPortalPass.value
          ? 'far far fa-pencil flex items-center justify-center'
          : 'fas fas fa-lock !text-cardinal dark:!text-cardinal flex items-center justify-center',
        to: '/my-account/player-notes',
      },
      {
        label: 'Log Out',
        icon: 'far far fa-sign-out flex items-center justify-center',
        click: () => onSignOut(),
      },
    ],
  ];
  if (profile.value.is_admin) {
    items.push([
      {
        label: 'Data Import',
        icon: 'far far fa-user-circle flex items-center justify-center',
        to: '/admin/data-import',
      },
      {
        label: 'Games',
        icon: 'far far fa-list flex items-center justify-center',
        to: '/admin/games',
      },
      {
        label: 'Plays',
        icon: 'far far fa-list flex items-center justify-center',
        to: '/admin/plays',
      },
    ]);
  }
  return items;
});
const onSignOut = async () => {
  queryClient.clear();
  await supabase.auth.signOut();
  store.resetProfile();
  if ($posthog) {
    const posthog = $posthog();
    posthog?.reset();
  }
  router.push('/');
};
</script>
